import { FormStructure } from '@europrocurement/flexy-form';

// Extract from getDomaines collection (label=libelle, value=iri)
export type SelectDomainsOptions = {
    label: string;
    value: string;
};

// Formstructure  Default style properties
const defaultStyle = {
    lg: 6,
    md: 6,
    sm: 12,
    fullWidth: true,
};

// Formstructure duplicate label and placeholder function
const getLabelProperties = (inputlabel: string) => ({
    inputlabel,
    placeholder: inputlabel,
});

/**
 * Regex / Validation rule part
 */
const validateHasNoDangerousChars = (value: string): boolean | string => {
    const forbiddenRegex = /[<>/;"'`*%#$=~]/g;
    return !forbiddenRegex.test(value) || 'Caractères spéciaux interdits.';
};

const validateEmailFormat = (emailFieldValue: string): boolean | string => {
    // If no value Validate = true since it's nullable
    if (!emailFieldValue) return true;

    // Else apply regex test
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(emailFieldValue) ? true : "Format d'email invalide";
};

const validatePhoneFormat = (phoneFieldValue: string): boolean | string => {
    // If no value Validate = true since it's nullable
    if (!phoneFieldValue) return true;

    // Check numbers length
    const cleaned = phoneFieldValue.replace(/[^0-9]/g, '');
    if (cleaned.length < 10 || cleaned.length > 13) {
        return 'Numéro de téléphone invalide (doit contenir entre 10 et 13 chiffres)';
    }

    // Check no consecutive special chars
    const consecutiveSpecialsRegex = /[.\-+ ]{2,}/;
    if (consecutiveSpecialsRegex.test(phoneFieldValue)) {
        return 'Le numéro contient des caractères spéciaux consécutifs';
    }

    const formatted = phoneFieldValue.replace(/[\s.()-]/g, '');
    const frenchNumberOnlyRegex = /^(\+33|0033|0)[1-9](\s?\d{2}){4}$/;
    if (!frenchNumberOnlyRegex.test(formatted)) {
        return "Le numéro n'est pas français";
    }

    // Else apply regex test
    const phoneRegex = /^[0-9.+\- ]*$/;
    return phoneRegex.test(phoneFieldValue) ? true : 'Format de téléphone invalide';
};

// Form structure
export const createWorkGroupFormStructure = (
    domainesOptionsList: SelectDomainsOptions[],
): FormStructure[] => {
    const workgroupInfosFromStructure: FormStructure[] = [
        {
            type: 'text',
            name: 'lib',
            rules: {
                required: true,
                validate: { validateHasNoDangerousChars },
            },
            ...getLabelProperties('Libellé'),
            ...defaultStyle,
        },
        {
            type: 'select',
            options: domainesOptionsList,
            name: 'domaine',
            inputlabel: 'Domaine',
            placeholder: 'Choisir le domaine',
            rules: { required: true },
            ...defaultStyle,
        },
        {
            type: 'email',
            name: 'email',
            rules: {
                required: false,
                validate: {
                    validateEmailFormat,
                    validateHasNoDangerousChars,
                },
            },
            ...getLabelProperties('Mail'),
            ...defaultStyle,
        },
        {
            type: 'text',
            name: 'phone',
            inputlabel: 'Téléphone',
            rules: {
                required: false,
                validate: { validatePhoneFormat },
            },
            placeholder: 'ex: 01 45 58 26 63',
            ...defaultStyle,
        },
        {
            type: 'date',
            name: 'dCreation',
            inputlabel: 'Date de création',
            rules: { required: true },
            ...defaultStyle,
        },
        {
            type: 'date',
            name: 'dCloture',
            inputlabel: 'Date de clôture',
            rules: { required: false },
            ...defaultStyle,
        },
    ];
    return workgroupInfosFromStructure;
};
